import { useMutation } from 'platform/useMutation';
import { gql } from '@apollo/client';
import { useObservability } from 'shared/helpers/observability';
import { useQualificationContext } from 'shared/helpers/QualificationContext';

export const SET_SSVA_SMS_REMINDER = gql`
  mutation SSVAReminder($uuid: String!, $phoneNumber: String!) {
    sellDirect {
      setSSVAReminderSMS(
        input: { lead: { source: { type: RECEPTION, id: $uuid } }, phoneNumber: $phoneNumber }
      ) {
        success
      }
    }
  }
`;

/** Sends a phone number to trigger a reminder sms job for a user */
export const useSetSMSReminder = () => {
  const { sellerInputUUID } = useQualificationContext();
  const { trackError } = useObservability();
  const [update, { loading, data, error }] = useMutation(SET_SSVA_SMS_REMINDER, {
    fetchPolicy: 'no-cache',
  });
  /** Expects a phone number string to set user sms reminders  */
  const setSMSReminder = (phoneNumber: string) =>
    update({
      variables: { uuid: sellerInputUUID, phoneNumber: phoneNumber },
    }).catch((error) => trackError('set-ssva-sms-reminder', error));

  return { setSMSReminder, data, loading, error };
};
